import {Button} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {NullAsDefault, renderElse} from 'views/Shared'
import {FaPrayingHands} from "react-icons/fa";
import WoGContext from "../WoGContext";
import {WoGActions} from "../routes";
import {BiSolidNetworkChart} from "react-icons/bi";
import {MdTopic} from "react-icons/md";
import {FaCircleInfo} from "react-icons/fa6";

const WoGShortcuts = ({current}) => {
  const t = useTranslate()
  const {item, handleAction = NullAsDefault} = useContext(WoGContext)

  return (
    <div  className="flex flex-center gap-2 overflow-y-hidden overflow-auto py-2">
      {[
        {
          label: 'book',
          icon: <FaCircleInfo size={16}/>,
          value: WoGActions.SHOW_BOOK_INFO_MODAL,
        },
        {
          label: 'divine word related',
          icon: <BiSolidNetworkChart size={16}/>,
          value: WoGActions.SHOW_RELATED_HASH_TAGS_MODAL,
        },
        {
          label: 'topics',
          icon: <MdTopic size={16}/>,
          value: WoGActions.SHOW_HASH_TAGS_MODAL,
        },
        {
          label: 'the meditation on God Word',
          icon: <FaPrayingHands size={16}/>,
          value: WoGActions.SHOW_MEDITATION_MODAL,
        },
      ].map(({label, icon, value}, index) => (
        <Button
          key={index}
          icon={icon}
          size={32}
          onClick={() => {
            handleAction(value)
          }}
          style={{ padding: 8 }}
          className="flex flex-center rounded-md bg-primary-50 hover:bg-primary-100 text-primary no-border">
          {renderElse(!!icon, t(label))}
        </Button>
      ))}
    </div>
  )
}

export default WoGShortcuts
